// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import './theme/element/index.css';
import config from'./config'
Vue.use(ElementUI);
// 挂载公共方法
import utils from './common/common.js'
Vue.prototype.$fxLink = utils
import * as commonJs from './utils/index.js'
Vue.prototype.$commonJs = commonJs
// 网络请求
import * as Api from './api/index.js'
Vue.prototype.$api = Api
import userLeft from './components/common/user/index.vue'
Vue.component('userLeft',userLeft)
Vue.prototype.$fff = false
import login from "./utils/LoginDialog.js"; // 登录弹窗全局组件
Vue.prototype.$namePc = config.name
Vue.prototype.$province = config.province
Vue.prototype.$login = login.install; // 全局可使用this.$login调用
// import layer from './layer/layer.js'
// // import layer from 'vue-layer'
// // import 'vue-layer/lib/vue-layer.css'
// Vue.prototype.layer = layer(Vue)
Vue.config.productionTip = false
Vue.prototype.$onLaunched = new Promise(resolve => {
  Vue.prototype.$isResolve = resolve
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js